import React from 'react'
import { css } from 'aphrodite'

import style from './style'

const Avatar = props => {
  return (
    <div
      className={`d-flex align-items-center justify-content-around ${css(
        style.box
      )}`}
      style={{ backgroundColor: props.bgColor }}
    >
      <span className={css(style.span)} style={{ color: props.textColor }}>
        {`${props.firstName[0]}${props.lastName[0]}`}
      </span>
    </div>
  )
}

export default Avatar



// WEBPACK FOOTER //
// ./src/components/User/partials/UserTable/partials/Avatar/index.js